// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3XpWW","buttons":"SendReceipts_buttons__3ZGAW","email":"SendReceipts_email__RwCng","bookApptTitle":"SendReceipts_bookApptTitle__2pWTC"};